/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var HandPointClickAIcon24Solid = forwardRef('HandPointClickAIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M11 .25a1 1 0 0 1 1 1v1.688a1 1 0 1 1-2 0V1.25a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M9 14.75V7a2 2 0 1 1 4 0v3.8l4.368.749a2.5 2.5 0 0 1 2.009 3.047l-1.317 5.487A2.5 2.5 0 0 1 15.629 22h-4.647a2.5 2.5 0 0 1-1.701-.668l-4.812-4.468a1.931 1.931 0 0 1 2.09-3.184L9 14.75Z" }),
        React.createElement("path", { d: "M17.5 8.75a1 1 0 1 0 0-2h-1.688a1 1 0 1 0 0 2H17.5Z" }),
        React.createElement("path", { d: "M6.188 8.75a1 1 0 1 0 0-2H4.5a1 1 0 1 0 0 2h1.688Z" }),
        React.createElement("path", { d: "M16.303 2.447a1 1 0 0 1 0 1.414L15.11 5.054a1 1 0 0 1-1.414-1.414l1.193-1.193a1 1 0 0 1 1.414 0Z" }),
        React.createElement("path", { d: "M6.89 5.054A1 1 0 0 0 8.304 3.64L7.11 2.447A1 1 0 0 0 5.696 3.86L6.89 5.054Z" })));
});
